<template lang="pug">
div
  UiCardSection
    UiTabs(
      :tabs="tabs"
      @select="activeTab = $event"
      :selected="activeTab"
      skin="light"
    )
  UiCardSection
    CompanyApprovers(v-if="activeTab === 'company_approvers'")
    TargetApprovers(
      v-if="activeTab === 'company_default_approvers'"
      :target="'company'"
      :target_id="this.$route.params.id"
    )
    ApprovalSettings(v-if="activeTab === 'approval_settings'")
    ApprovalLogs(v-if="activeTab === 'approval_logs'")
</template>

<script>
import CompanyApprovers from "@/views/Approvers/company_approvers.vue";
import ApprovalSettings from "@/views/Approvers/company_approval_settings.vue";
import TargetApprovers from "@/views/Approvers/index.vue";
import ApprovalLogs from "@/views/Approvers/logs.vue";

export default {
  components: {
    ApprovalSettings,
    TargetApprovers,
    CompanyApprovers,
    ApprovalLogs,
  },

  data() {
    return {
      activeTab: "company_approvers",
    };
  },

  computed: {
    tabs() {
      return [
        {
          id: "company_approvers",
          label: this.$t("companies.approvers.company_approvers_tab"),
        },
        {
          id: "company_default_approvers",
          label: this.$t("companies.approvers.company_default_approvers_tab"),
        },
        {
          id: "approval_settings",
          label: this.$t("companies.approvers.approval_settings_tab"),
        },
        {
          id: "approval_logs",
          label: this.$t("companies.approvers.approval_logs_tab"),
        },
      ];
    },
  },
};
</script>
